import { result } from "lodash";
import React, { FC, memo, useState, useEffect } from "../../../../lib/teact/teact";
import Button from "../../../ui/Button";
import MessageEditor from "../../message/messageEditor";
import Parser from "../../restapi/parser";
import store from "../../store";
import { catChuyenTuyChon, getLocalKeyCatTuyChon } from "./catchuyenlib";
import { isCuPhapMb } from "../../utils/common";

type OwnProps = {
    chuId: number;
    onConfirm: (params: any) => void;
    onPlayOn789: (parserResult: any) => void;
}
const ChuyenTuyChon: FC<OwnProps> = ({ chuId,
    onConfirm,
    onPlayOn789,
}) => {
    const [state, setState] = useState({
        rawText: '',
        htmlError: '',
        errorTextToUser: ''

    })
    async function parseText(): Promise<any> {

        const contactId = chuId;
        const payload = {
            body: state.rawText,
            date: store.getState().global.workDate,
            time: "00:00:59",
            type: 1,
            contactId: contactId,
            mien: isCuPhapMb() ? "BAC" : "NAM",
            curMien: isCuPhapMb() ? "BAC" : "NAM",
            getCompactData: 1,
            getRawData: 0,
            mienCuPhapId: isCuPhapMb() ? 1 : 2,
            tachXienMay: 3,
            soBoSo: 10,
        }
        let result = await Parser.parseCanChuyenMessage(payload)
        let html = result.data.html
        if (html == "")
            html = result.data.bodyViet
        setState(prev => ({ ...prev, htmlError: html, errorTextToUser: result.responseText }))
        if (result.data.parseStatus == "parseOK") {
            console.log(result.data)

        }
        return result.data;
    }
    async function handleParseText(e: React.MouseEvent<HTMLButtonElement, MouseEvent>): Promise<void> {
        e.preventDefault();
        const param = await parseText();
        if (param.parseStatus == "parseOK") {
            const tmp = { ...state };
            tmp.htmlError = tmp.rawText;
            onConfirm(param);
            const key = getLocalKeyCatTuyChon(chuId);
            localStorage[key] = JSON.stringify(tmp);

        }

    }
    useEffect(() => {
        const key = getLocalKeyCatTuyChon(chuId);
        const saved = localStorage[key];
        if (saved) {
            const savedObject = JSON.parse(saved);
            setState(prev => ({ ...prev, ...savedObject }));
        }
    }, [chuId]);
    return (
        <>
            <MessageEditor onTextChange={(html, rawText) => {
                setState(prev => ({ ...prev, rawText: rawText }))
            }}


                htmlError={state.htmlError}
                errorTextToUser={state.errorTextToUser}
                msgType={1} />
            <div className=" common-container-col" style='gap:5px;'>
                <Button size="smaller" onClick={handleParseText}>Chuyển</Button>
                <Button onClick={async () => {
                    const param = await parseText();
                    if (param.parseStatus == "parseOK") {
                        const tmp = { ...state };
                        tmp.htmlError = tmp.rawText;

                        const key = getLocalKeyCatTuyChon(chuId);
                        localStorage[key] = JSON.stringify(tmp);
                        onPlayOn789(param);
                    }

                }} size="smaller">Chuyển one789</Button>
            </div>
        </>
    )
}

export default memo(ChuyenTuyChon);